export default {
  header: 'Tilauksen yhteenveto',
  buttons: {
    checkout: 'Turvallinen kassa',
    continue: 'Jatka',
    add_products: '+ Lisää tuotteita',
    add_items: '+ Lisää tuotteita',
    menu: 'Ruokalista',
  },
  empty_order_basket: {
    description: 'Ostoskorisi on tyhjä <br/> Lisää tuotteita aloittaaksesi',
  },
  promo_code_banner: {
    single_use: '{{discount}} alennus - {{code}}',
    multi_use: '{{discount}} alennus {{count}} tilauksesta - {{code}}',
    redeem: 'LUNASTA',
    redeemed: 'LUNASTETTU',
  },
  upsell: {
    title: 'Muut tilaavat myös',
  },
  rewards: {
    title: 'Maksa pisteillä',
    description: '<highlight>Kirjaudu sisään</highlight> maksaaksesi pisteillä',
  },
  already_member: 'Oletko jo jäsen?',
  sign_in: 'Kirjaudu sisään',
  summary: {
    subtotal: 'Välisumma',
    delivery: 'Toimitus',
    pickup: 'Nouto',
    total: 'Yhteensä',
    free: 'Ilmainen',
  },
  footer: {
    member_earning: '+{{points}} pistettä tilauksen jälkeen · {{balance}} pisteen saldo',
    guest_earning: 'Rekisteröidy ansaitaksesi pisteitä tästä tilauksesta',
  },
};
